module.exports = __webpack_public_path__ + "img/Topic-physicalactivity.00d2e6bb.svg";